import Vue from 'vue'
export function Array2Obj(array) {
    let obj = {}
    for (let index = 0; index < array.length; index++) {
        let element = array[index];
        Vue.set(obj, element.key, element.authority)
    }

    return obj
}